import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-email.svg";
import * as styles from "./Icon.module.scss";

type EmailProps = React.SVGProps<SVGSVGElement>;

export const Email = ({ className, ...props }: EmailProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
